import React from "react";
import Link from "../Link";
import vect9 from "../../img/vector-9-black.svg"
import right2 from "../../img/right@2x.svg";
import "./ExpenseBreakdownButton.css";

const ExpenseBreakdownButton = (props) => {
    const { className, logo } = props;

    return (
        <Link href="/expense-breakdown-page">
            <div className="expenses-breakdown-button">
                <img className="vector-64" src={`${logo || vect9}`} />
                <div className={`expense-breakdown ${className || "nunito-bold-black-14px"}`}>Expense Breakdown</div>
                <img className="right-7" src={right2} />
            </div>
        </Link>
    );
};
export default ExpenseBreakdownButton;